import { COVERGO_SAAS_DEV, COVERGO_ASIA_PROD } from "../consts.js"

export const bupa = {
	// Bupa UAT
	"bupa-uat-studio.quote.hk": {
		appConfig: {
			tenantId: "bupa_uat",
			appId: "admin_portal",
		},
		envConfig: COVERGO_SAAS_DEV,
	},
	// Bupa DEV
	"bupa-dev-studio.quote.hk": {
		appConfig: {
			tenantId: "bupa_dev",
			appId: "admin_portal",
		},
		envConfig: COVERGO_SAAS_DEV,
	},
	// Bupa PROD
	"bupa-studio.quote.hk": {
		appConfig: {
			tenantId: "bupa",
			appId: "admin_portal",
		},
		envConfig: COVERGO_ASIA_PROD,
	},
	// Bupa Enterprise tenant
	"studio.dev.bupa.hk.covergo.net": {
		appConfig: {
			tenantId: "bupa_dev",
			appId: "admin_portal",
		},
		envConfig: {
			COVERGO_GRAPHQL: "https://api.dev.bupa.hk.covergo.net/graphql",
			COVERGO_FILE_SYSTEM: "https://api.dev.bupa.hk.covergo.net/api/v1/files",
		},
	},
	"studio.uat.bupa.hk.covergo.net": {
		appConfig: {
			tenantId: "bupa_uat",
			appId: "admin_portal",
		},
		envConfig: {
			COVERGO_GRAPHQL: "https://api.uat.bupa.hk.covergo.net/graphql",
			COVERGO_FILE_SYSTEM: "https://api.uat.bupa.hk.covergo.net/api/v1/files",
		},
	},
	"studio-dm.uat.bupa.hk.covergo.net": {
		appConfig: {
			tenantId: "bupa_uat_dm",
			appId: "admin_portal",
		},
		envConfig: {
			COVERGO_GRAPHQL: "https://api.uat.bupa.hk.covergo.net/graphql",
			COVERGO_FILE_SYSTEM: "https://api.uat.bupa.hk.covergo.net/api/v1/files",
		},
	},
	"studio-qa.uat.bupa.hk.covergo.net": {
		appConfig: {
			tenantId: "bupa_qa",
			appId: "admin_portal",
		},
		envConfig: {
			COVERGO_GRAPHQL: "https://api.uat.bupa.hk.covergo.net/graphql",
			COVERGO_FILE_SYSTEM: "https://api.uat.bupa.hk.covergo.net/api/v1/files",
		},
	},
	"studio.bupa.hk.covergo.net": {
		appConfig: {
			tenantId: "bupa",
			appId: "admin_portal",
		},
		envConfig: {
			COVERGO_GRAPHQL: "https://api.bupa.hk.covergo.net/graphql",
			COVERGO_FILE_SYSTEM: "https://api.bupa.hk.covergo.net/api/v1/files",
		},
	},
	"studio.prod.bupa.hk.covergo.net": {
		appConfig: {
			tenantId: "bupa",
			appId: "admin_portal",
		},
		envConfig: {
			COVERGO_GRAPHQL: "https://api.prod.bupa.hk.covergo.net/graphql",
			COVERGO_FILE_SYSTEM: "https://api.prod.bupa.hk.covergo.net/api/v1/files",
		},
	},
	// Bupa Broker Portal - DEV
	"studio-bp.dev.bupa.hk.covergo.net": {
		appConfig: {
			tenantId: "bp_dev",
			appId: "admin_portal",
		},
		envConfig: {
			COVERGO_GRAPHQL: "https://api.dev.bupa.hk.covergo.net/graphql",
			COVERGO_FILE_SYSTEM: "https://api.dev.bupa.hk.covergo.net/api/v1/files",
		},
	},
	// Bupa Broker Portal - UAT
	"studio-bp.uat.bupa.hk.covergo.net": {
		appConfig: {
			tenantId: "bp_uat",
			appId: "admin_portal",
		},
		envConfig: {
			COVERGO_GRAPHQL: "https://api.uat.bupa.hk.covergo.net/graphql",
			COVERGO_FILE_SYSTEM: "https://api.uat.bupa.hk.covergo.net/api/v1/files",
		},
	},
	// Bupa Broker Portal - PROD
	"studio-bp.prod.bupa.hk.covergo.net": {
		appConfig: {
			tenantId: "bp_prod",
			appId: "admin_portal",
		},
		envConfig: {
			COVERGO_GRAPHQL: "https://api.prod.bupa.hk.covergo.net/graphql",
			COVERGO_FILE_SYSTEM: "https://api.prod.bupa.hk.covergo.net/api/v1/files",
		},
	},
	// Bupa Sub DEV
	"bp-sub-studio.dev.bupa.hk.covergo.net": {
		appConfig: {
			tenantId: "bupa_sub_dev",
			appId: "admin_portal",
		},
		envConfig: {
			COVERGO_GRAPHQL: "https://api-sub.dev.bupa.hk.covergo.net/graphql",
			COVERGO_FILE_SYSTEM: "https://api-sub.dev.bupa.hk.covergo.net/api/v1/files",
		}

		}
}
